window.arjoTabContainerJs = window.arjoTabContainerJs || {
  isInitialized: false,
  setup: function () {
    const tabContainers = [...document.querySelectorAll('.arjo-o-tab-container')];

    tabContainers.forEach((tabContainer) => {
      const tabSwitcher = tabContainer.querySelector('.arjo-m-tab-switcher');
      if (!tabSwitcher) {
        return;
      }

      const tabContainerInner = tabContainer.querySelector('.arjo-m-tab-switcher__container');
      const tabBar = tabContainerInner.querySelector('.arjo-m-tab-switcher__tabs');
      const selectedRadio = tabBar.querySelector('.arjo-m-tab-switcher__input:checked');
      if (!selectedRadio) {
        return;
      }

      const tabBarHeader = tabContainerInner.querySelector('.arjo-m-tab-switcher__header');
      if (!tabBarHeader) {
        return;
      }

      tabBarHeader.addEventListener('click', function () {
        tabSwitcher.toggleAttribute('data-arjo-expand');
      });

      document.addEventListener('click', function (e) {
        if (!tabSwitcher.contains(e.target)) {
          tabSwitcher.removeAttribute('data-arjo-expand');
        }
      });
    });

    const url = new URL(location.href);
    const inputDownload = document.querySelector('.arjo-m-tab-switcher__input[data-download-tab]');

    if (!inputDownload) {
      return;
    }

    const tabContainer = inputDownload.closest('.arjo-o-tab-container');

    if (url.searchParams.get('showdownload') == 'true') {
      inputDownload.checked = true;
      tabContainer && tabContainer.scrollIntoViewEx();
    }
  },
  resizeHandler: function () {
    const tabContainers = [...document.querySelectorAll('.arjo-o-tab-container')];
    tabContainers.forEach((tabContainer) => {
      const tabSwitcher = tabContainer.querySelector('.arjo-m-tab-switcher');
      if (!tabSwitcher) {
        return;
      }
      const tabContainerInner = tabSwitcher.querySelector('.arjo-m-tab-switcher__container');
      const tabBar = tabContainerInner.querySelector('.arjo-m-tab-switcher__tabs');
      const selectedRadio = tabBar.querySelector('.arjo-m-tab-switcher__input:checked');
      if (!selectedRadio) {
        return;
      }

      const tabBarHeader = tabContainerInner.querySelector('.arjo-m-tab-switcher__header');
      if (!tabBarHeader) {
        return;
      }

      const tabBarHeaderText = tabBarHeader.querySelector('.arjo-m-tab-switcher__text');
      if (!tabBarHeaderText) {
        return;
      }

      const selectedLabel = tabBar.querySelector('label[for="' + selectedRadio.id + '"]');
      if (!selectedLabel) {
        return;
      }

      tabSwitcher.removeAttribute('data-arjo-expand');

      const selectedLabelTextContent = selectedLabel?.querySelector('.arjo-m-tab-switcher__label-text')?.textContent;

      tabBarHeaderText.textContent = selectedLabelTextContent ?? '';

      const tabBarBoundingClientRect = tabBar.getBoundingClientRect();
      const labelBoundingClientRect = selectedLabel.getBoundingClientRect();
      const labelOffsetX = labelBoundingClientRect.x - tabBarBoundingClientRect.x;
      const labelWidth = labelBoundingClientRect.width;

      tabBar.style.setProperty('--tabOffsetX', labelOffsetX + 'px');
      tabBar.style.setProperty('--tabWidth', labelWidth + 'px');

      const selectedTabIndex = selectedRadio.getAttribute('data-arjo-tab');
      const tabItems = [...tabContainer.querySelectorAll('div[data-arjo-tab]')];
      tabItems.forEach((tabItem) => {
        tabItem.style.display = tabItem.getAttribute('data-arjo-tab') == selectedTabIndex ? 'block' : 'none';
      });
    });
  },

  init: function () {
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;

    this.setup();

    addEventListener('resize', this.resizeHandler);
    var tabRadios = [...document.querySelectorAll('.arjo-m-tab-switcher__input')];
    tabRadios.forEach((tabRadio) => {
      if ('#' + tabRadio.id === window.location.hash) {
        tabRadio.checked = true;
        var tabContainer = tabRadio.closest('.arjo-o-tab-container');
        if (tabContainer) {
          tabContainer.scrollIntoViewEx();
        }
      }
      tabRadio.addEventListener('change', () => {
        window.location.hash = '#' + tabRadio.id;
        this.resizeHandler();
      });
    });

    this.resizeHandler();
  },
};

window.addEventListener('load', function () {
  window.arjoTabContainerJs.init();
});
